import builder from '../builder';
import ButtonRefreshArrows from '../../streamline-icons/light/button-refresh-arrows.svg';

export default builder('IconButtonRefreshArrowsLight', ButtonRefreshArrows);
